import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import componentBase from '../../../src/lib/component-base';
import AirportDetailsHeader from './children/Header/AirportDetailsHeader';
import ConditionsTracker from './children/ConditionsTracker/AirportConditionsTracker';
import WeatherForecast from './children/WeatherForcast/AirportWeatherForecast';
import AirportCurrentConditionsSearch from './children/Search/AirportCurrentConditionsSearch';
import { setAirport, loadDetailsByCode, setSecondaryAction } from '../redux/actions';
import { AirportCurrentConditions } from './ads';
import { addMetaCanonical } from '../../../shared/lib/meta-tags';
import BannerAd from '../../../shared/components/BannerAd/BannerAd';

const { topMobile, top } = AirportCurrentConditions;

const Ad = ({ subscriptionActive }) => (
  <BannerAd
    topAd
    mobileAd={topMobile}
    desktopAd={top}
    subscriptionActive={subscriptionActive}
  />
);

Ad.propTypes = {
  subscriptionActive: PropTypes.bool,
};

@connect(state => ({
  airport: state.AirportCurrentConditions.airport,
  detailsHeader: state.AirportCurrentConditions.detailsHeader,
  forecastWeather: state.AirportCurrentConditions.forecastWeather,
  delayIndex: state.AirportCurrentConditions.delayIndex,
  currentWeather: state.AirportCurrentConditions.currentWeather,
  airportCode: state.AirportCurrentConditions.airportCode,
  error: state.AirportCurrentConditions.error,
  loading: state.AirportCurrentConditions.loading,
  loaded: state.AirportCurrentConditions.loaded,
  airportSearchItem: state.AirportCurrentConditions.airportSearchItem,
  callSecondaryAction: state.AirportCurrentConditions.callSecondaryAction,
}))
@componentBase('CurrentConditions')
class CurrentConditions extends Component {
  static propTypes = {
    airportSearchItem: PropTypes.object,
    detailsHeader: PropTypes.object,
    dispatch: PropTypes.func,
    airport: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    name: PropTypes.string,
    params: PropTypes.object,
    callSecondaryAction: PropTypes.bool,
  };

  componentDidMount() {
    const { dispatch, match } = this.props;

    dispatch(loadDetailsByCode(match.params));
  }

  componentWillReceiveProps(nextProps) {
    const { pathname } = this.props.location;

    if (pathname !== nextProps.location.pathname) {
      this.props.dispatch(loadDetailsByCode(nextProps.match.params));
    }

    const { callSecondaryAction, dispatch } = nextProps;
    if (callSecondaryAction) {
      dispatch(setSecondaryAction(false));
    }
  }

  metaTags = () => {
    const { detailsHeader = {} } = this.props;
    const {
      code,
      city,
      name,
    } = detailsHeader;

    const title = code && name ? `(${code}) ${name} Conditions` : 'Airport Conditions';
    const description = `Current weather and delay conditions for (${code}) ${name} Conditions`;
    const keywords = `${code} ${name} ${city} weather delay conditions`;
    const metaWithoutCanonical = {
      title,
      meta: [
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
      ],
    };
    return addMetaCanonical(metaWithoutCanonical, this.props.location.pathname);
  };

  render() {
    const { airport, airportSearchItem, dispatch, callSecondaryAction } = this.props;
    const meta = this.metaTags();
    const subscriptionActive = (
      this.context &&
      this.context.currentUser &&
      this.context.currentUser.subscriptionActive
    );

    return (
      <div style={{ width: '100%', padding: 0, margin: 0 }}>
        <Helmet {...meta} />
        <AirportCurrentConditionsSearch
          airport={airportSearchItem}
          dispatch={dispatch}
          onChange={(option, triggeredByEnter) => dispatch(setAirport(option, triggeredByEnter))}
          callSecondaryAction={callSecondaryAction}
        />
        <Ad subscriptionActive={subscriptionActive} />
        {airport && <AirportDetailsHeader {...airport} />}
        {airport && <ConditionsTracker {...this.props} />}
        {airport && <WeatherForecast {...this.props} />}
      </div>
    );
  }
}

export default CurrentConditions;



// WEBPACK FOOTER //
// ./modules/AirportCurrentConditions/components/CurrentConditionsContainer.js